/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Customer_Contract_Prepaid_Too_LargeInputs */



/**
* | output |
* | --- |
* | "The prepaid budget can be at most €10,000,000." |
*
* @param {Partner_Add_Customer_Contract_Prepaid_Too_LargeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_customer_contract_prepaid_too_large = /** @type {((inputs?: Partner_Add_Customer_Contract_Prepaid_Too_LargeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Customer_Contract_Prepaid_Too_LargeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das vorausbezahlte Budget darf höchstens 10.000.000 € betragen.")
	return /** @type {LocalizedString} */ ("The prepaid budget can be at most €10,000,000.")
});